/**
 * Cliente de auth del frontend-superadmin.
 *
 * Llama al endpoint `GET /auth/me` del backend Calbucura (el mismo
 * que usa el portal vecino). El backend retorna el usuario logueado
 * con sus roles; el frontend valida que `super_admin` esté en
 * `roles_vigentes` antes de permitir acceso a rutas protegidas.
 */
import { apiFetch } from './client';
import type { AuthMeResponse } from './types';

export function getMe(): Promise<AuthMeResponse> {
  return apiFetch<AuthMeResponse>('/auth/me');
}
